<template>
  <div class="header">
    <div class="logo">
      <div class="img">
        <img src="../../assets/img/login/logo.png" alt="logo" />
      </div>
      <div>亚太陈皮</div>
    </div>
    <el-tooltip effect="dark" :content="sidebar.opened ? '收缩菜单' : '展开菜单'">
      <Hamburger
        id="hamburger-container"
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar"
      />
    </el-tooltip>
    <div class="menu">
      <!-- <el-menu
        class="el-menu-demo"
        mode="horizontal"
        @select="() => { }"
        background-color="#3498db"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-submenu index="2">
          <template slot="title">我的工作台</template>
          <el-menu-item index="2-1">选项1</el-menu-item>
          <el-menu-item index="2-2">选项2</el-menu-item>
          <el-menu-item index="2-3">选项3</el-menu-item>
          <el-submenu index="2-4">
            <template slot="title">选项4</template>
            <el-menu-item index="2-4-1">选项1</el-menu-item>
            <el-menu-item index="2-4-2">选项2</el-menu-item>
            <el-menu-item index="2-4-3">选项3</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-menu-item index="3" disabled>消息中心</el-menu-item>
        <el-menu-item index="4">
          <a href="https://www.ele.me" target="_blank">订单管理</a>
        </el-menu-item>
      </el-menu>-->
      <div class="my">
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
          @select="() => { }"
          background-color="#ece4ce"
          text-color="#000"
          active-text-color="#409EFF"
        >
          <el-submenu index="2">
            <template slot="title">
              <el-avatar
                class="img"
                src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
              ></el-avatar>
              <span>{{ nickName }}</span>
            </template>
            <!-- <el-menu-item index="2-1">选项1</el-menu-item>
            <el-menu-item index="2-2">选项2</el-menu-item>-->
            <el-menu-item index="2-3" @click="loginOut">退出登陆</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
import { loginOut } from '../../api/login'
import Hamburger from '@/components/Hamburger'
export default {
  components: {
    Hamburger,
  },
  data() {
    return {
      sidebar: {
        opened: true,
      },
    }
  },
  computed: {
    nickName() {
      return sessionStorage.getItem('nickName')
    },
  },
  methods: {
    toggleSideBar() {
      this.sidebar.opened = !this.sidebar.opened
      this.$emit('toggleSideBar', this.sidebar.opened)
    },
    async loginOut() {
      const { code } = await loginOut()
      if (code == 200) {
        // sessionStorage.clear()
        this.$router.push('/login')
      }
      // code === 200 ? this.$router.push('/login') : this.$message.error('退出成功')
    },
  },
}
</script>
<style lang="less" scoped>
@import '../../assets/variables.less';
.hamburger-container {
  line-height: 46px;
  height: 100%;
  float: left;
  margin-left: 10px;
  margin-top: 5px;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}

.breadcrumb-container {
  float: left;
}
.header {
  height: 100%;
  padding: 0 20px;
  display: flex;
  background-color: @primary-color;
  overflow: hidden;
  // justify-content: space-between;

  /deep/.el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .logo {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 24px;

    .img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }

  .menu {
    display: flex;
    align-items: center;

    .el-menu-demo {
      // background-color: @primary-color !important;
      height: 60px;
      .img {
        margin-right: 10px;
      }
    }

    .my {
      margin-left: 10px;
      position: absolute;
      right: 10px;
      .contorl {
        position: absolute;
        background-color: rebeccapurple;
        width: 200px;
        height: 200px;
        // top: 100px;
      }
    }
  }
}
img {
  width: 100%;
  height: 100%;
}
</style>